import { apiClient } from './api';
import type { Node, Edge, Viewport } from '@xyflow/react';

export interface FlowNodeType {
  id: string;
  category: 'source' | 'transform' | 'destination';
  label: string;
  description: string | null;
  icon: string | null;
  platforms: string[] | null;
  config_schema: Record<string, unknown> | null;
  sort_order: number;
  is_active: boolean;
}

export interface FlowDefinition {
  id: string;
  tenant_id: string;
  name: string;
  description: string | null;
  nodes: Node[];
  edges: Edge[];
  viewport: Viewport | null;
  status: 'draft' | 'active' | 'archived';
  created_at: string;
  updated_at: string;
}

export interface CreateFlowDefinitionRequest {
  name: string;
  description?: string;
  nodes: Node[];
  edges: Edge[];
  viewport?: Viewport;
}

export interface UpdateFlowDefinitionRequest {
  name?: string;
  description?: string;
  nodes?: Node[];
  edges?: Edge[];
  viewport?: Viewport;
  status?: string;
}

export const flowDefinitionService = {
  async getAll(): Promise<FlowDefinition[]> {
    return apiClient.get<FlowDefinition[]>('/flow-definitions');
  },

  async getById(id: string): Promise<FlowDefinition> {
    return apiClient.get<FlowDefinition>(`/flow-definitions/${id}`);
  },

  async create(data: CreateFlowDefinitionRequest): Promise<FlowDefinition> {
    return apiClient.post<FlowDefinition>('/flow-definitions', data);
  },

  async update(id: string, data: UpdateFlowDefinitionRequest): Promise<FlowDefinition> {
    return apiClient.put<FlowDefinition>(`/flow-definitions/${id}`, data);
  },

  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`/flow-definitions/${id}`);
  },

  async getNodeTypes(): Promise<FlowNodeType[]> {
    return apiClient.get<FlowNodeType[]>('/flow-node-types');
  },
};
